import { Component, OnInit } from '@angular/core';
import { AppelsService } from '../../service/appels.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HorsParcourCertificate } from 'src/app/model/hors-parcours-certificate.model';
import { tap } from 'rxjs';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-hors-sigui-certificate',
  templateUrl: './hors-sigui-certificate.component.html',
  styleUrls: ['./hors-sigui-certificate.component.css'],
})
export class HorsSiguiCertificateComponent implements OnInit {
  hpcertificateForm!: FormGroup;

  valid!: boolean;
  inValid!: boolean;
  error!: boolean;
  successMessage: string | null = null;
  errorMessage: string | null = null;
  isClosing = false;
  inValidId!: boolean;
  inValidName!: boolean;
  inValidShort!: boolean;
  inValidStartdate!: boolean;
  inValidEnddate!: boolean;
  inValidAppeldate!: boolean;
  urlCertificat!: boolean;
  invalidDisplayname!: boolean;
  invalidFullname!: boolean;
  invalidPlatforme!: boolean;
  invalidCategorie!: boolean;
  invalidUrl!: boolean;
  invalidDescription!: boolean;

  platforms: string[] = ['Moodle', 'Coursera'];
  categorys!: any[];

  user: any;
  iuf!: string;

  showConfirmModal = false;
  //***************liste des certificats*****************
  certificatCodes: any[] = [];
  isDuplicating: boolean = false;
  constructor(
    private appelService: AppelsService,
    private fb: FormBuilder,
    private router: Router,
    
    private route: ActivatedRoute,
  ) {
    this.user = sessionStorage.getItem('user');
    this.iuf = JSON.parse(this.user).iuf;
  }
  ngOnInit(): void {
    this.hpcertificateForm = this.fb.group({
      idcertificat: ['', Validators.required],
      name: ['', Validators.required],
      shortname: ['', Validators.required],
      fullname: ['', Validators.required],
      displayname: ['', Validators.required],
      urlCertificat: ['', Validators.required],
      plateforme: ['', Validators.required],
      enddate: ['', Validators.required],
      appeldate: ['', Validators.required],
      startdate: ['', Validators.required],
      description: ['', Validators.required],
      category: ['', Validators.required],
      // 👈 AJOUTE CETTE LIGNE (optionnel, pas de Validators.required)
      certificatCode: [''], 
    });

// 👇 AJOUTE CE BLOC ICI, juste après la fermeture du fb.group ci-dessus
    const externalIdToDuplicate = this.route.snapshot.paramMap.get('externalId');
    if (externalIdToDuplicate) {
      //pour permettre la saisie sur le champs cetificatcode lors de la duplication 
      this.isDuplicating = true; // 👈 AJOUTE CETTE LIGNE
      this.appelService.getCertificateForDuplication(externalIdToDuplicate).subscribe({
        next: (data) => {
          this.hpcertificateForm.patchValue({
            name: data.name,
            shortname: data.shortname,
            fullname: data.fullname,
            displayname: data.displayname,
            urlCertificat: data.urlCertificat,
            plateforme: data.plateforme,
            startdate: data.startDate,
            enddate: data.endDate,
            description: data.description,
            category: data.category,
// 👈 *********************AJOUTE CETTE LIGNE*********************
            certificatCode: data.certificatCode, 
          });
        },
        error: () => {
          this.errorMessage = "Impossible de charger le certificat à dupliquer.";
        },
      });
    }
    // 👆 FIN DU BLOC AJOUTÉ

    this.appelService
      .listCategory()
      .pipe()
      .subscribe({
        next: (response) => {
          this.categorys = response;
        },
        error: (err) => {},
      });
      //*********************recuperation de la liste des certificatcode********************
      this.appelService.getAllCertificatCodes().subscribe({
        next: (response) => {
          this.certificatCodes = response;
        },
        error: () => {},
      });
    this.hpcertificateForm
      .get('idcertificat')
      ?.valueChanges.subscribe((values) => {
        if (values.length > 0) {
          this.inValidId = false;
        }
      });
    this.hpcertificateForm.get('name')?.valueChanges.subscribe((values) => {
      if (values.length > 0) {
        this.inValidName = false;
      }
    });
    this.hpcertificateForm
      .get('shortname')
      ?.valueChanges.subscribe((values) => {
        if (values.length > 0) {
          this.inValidShort = false;
        }
      });
    this.hpcertificateForm.get('fullname')?.valueChanges.subscribe((values) => {
      if (values.length > 0) {
        this.invalidFullname = false;
      }
    });
    this.hpcertificateForm
      .get('displayname')
      ?.valueChanges.subscribe((values) => {
        if (values.length > 0) {
          this.invalidDisplayname = false;
        }
      });
    this.hpcertificateForm
      .get('urlCertificat')
      ?.valueChanges.subscribe((values) => {
        if (values.length > 0) {
          this.invalidUrl = false;
        }
      });
    this.hpcertificateForm.get('category')?.valueChanges.subscribe((values) => {
      if (values.length > 0) {
        this.invalidCategorie = false;
      }
    });
    this.hpcertificateForm
      .get('plateforme')
      ?.valueChanges.subscribe((values) => {
        if (values.length > 0) {
          this.invalidPlatforme = false;
        }
      });
    this.hpcertificateForm.get('enddate')?.valueChanges.subscribe((values) => {
      if (values.length > 0) {
        this.inValidEnddate = false;
      }
    });
    this.hpcertificateForm
      .get('appeldate')
      ?.valueChanges.subscribe((values) => {
        if (values.length > 0) {
          this.inValidAppeldate = false;
        }
      });
    this.hpcertificateForm
      .get('startdate')
      ?.valueChanges.subscribe((values) => {
        if (values.length > 0) {
          this.inValidStartdate = false;
        }
      });
    this.hpcertificateForm
      .get('description')
      ?.valueChanges.subscribe((values) => {
        if (values.length > 0) {
          this.invalidDescription = false;
        }
      });
  }

  createHorsParcoursCertificate() {
    const formValue = this.hpcertificateForm.value;

    if (this.hpcertificateForm.valid) {
      const formValue = this.hpcertificateForm.value;
      const dateDeAppel: string =
        this.hpcertificateForm.controls['appeldate'].value;

      const cohorte = this.createCohorte(dateDeAppel);

      const horsParcoursCertificate = new HorsParcourCertificate(
        formValue['name'],
        formValue['shortname'],
        formValue['fullname'],
        formValue['displayname'],
        formValue['startdate'],
        formValue['enddate'],
        formValue['urlCertificat'],
        formValue['plateforme'],
        formValue['description'],
        '',
        +formValue['category'],
        formValue['idcertificat'],
       
        cohorte,
        this.iuf,
         formValue['certificatCode'], // 👈 AJOUTE CE PARAMÈTRE
      );

      this.appelService
  .createHorsParcoursCertificate(horsParcoursCertificate)
  .pipe(
    tap((response) => {
      if (response.status == 201) {
        window.scrollTo(0, 0);
        this.hpcertificateForm.reset();

        this.successMessage = 'Le certificat a été créé avec succès.';

        setTimeout(() => {
          this.isClosing = true;
        }, 2300);

        setTimeout(() => {
          this.router.navigate(['/dashboard/appels/sigui-certificat']);
        }, 2800);
      } else {
        window.scrollTo(0, 0);

        this.errorMessage =
          "Une erreur est survenue lors de la création du certificat. Veuillez réessayer.";

        setTimeout(() => {
          this.errorMessage = null;
        }, 3000);
      }
    }),
  )
  .subscribe();
    } else {
      window.scrollTo(0, 0);

      this.inValid = true;
      setTimeout(() => {
        this.inValid = false;
      }, 3000);

      const formValue = this.hpcertificateForm.value;

      if (
        formValue['idcertificat'] == undefined ||
        formValue['idcertificat'] == null ||
        formValue['idcertificat'] == ''
      ) {
        this.inValidId = true;
      } else {
        this.inValidId = false;
      }
      if (
        formValue['name'] == undefined ||
        formValue['name'] == null ||
        formValue['name'] == ''
      ) {
        this.inValidName = true;
      } else {
        this.inValidName = false;
      }
      if (
        formValue['shortname'] == undefined ||
        formValue['shortname'] == null ||
        formValue['shortname'] == ''
      ) {
        this.inValidShort = true;
      } else {
        this.inValidShort = false;
      }
      if (
        formValue['displayname'] == undefined ||
        formValue['displayname'] == null ||
        formValue['displayname'] == ''
      ) {
        this.invalidDisplayname = true;
      } else {
        this.invalidDisplayname = false;
      }

      if (
        formValue['startdate'] == undefined ||
        formValue['startdate'] == null ||
        formValue['startdate'] == ''
      ) {
        this.inValidStartdate = true;
      } else {
        this.inValidStartdate = false;
      }
      if (
        formValue['enddate'] == undefined ||
        formValue['enddate'] == null ||
        formValue['enddate'] == ''
      ) {
        this.inValidEnddate = true;
      } else {
        this.inValidEnddate = false;
      }
      if (
        formValue['category'] == undefined ||
        formValue['category'] == null ||
        formValue['category'] == ''
      ) {
        this.invalidCategorie = true;
      } else {
        this.invalidCategorie = false;
      }
      if (
        formValue['plateforme'] == undefined ||
        formValue['plateforme'] == null ||
        formValue['plateforme'] == ''
      ) {
        this.invalidPlatforme = true;
      } else {
        this.invalidPlatforme = false;
      }
      if (
        formValue['fullname'] == undefined ||
        formValue['fullname'] == null ||
        formValue['fullname'] == ''
      ) {
        this.invalidFullname = true;
      } else {
        this.invalidFullname = false;
      }
      if (
        formValue['urlCertificat'] == undefined ||
        formValue['urlCertificat'] == null ||
        formValue['urlCertificat'] == ''
      ) {
        this.invalidUrl = true;
      } else {
        this.invalidUrl = false;
      }

      if (
        formValue['description'] == undefined ||
        formValue['description'] == null ||
        formValue['description'] == ''
      ) {
        this.invalidDescription = true;
      } else {
        this.invalidDescription = false;
      }
      if (
        formValue['appeldate'] == undefined ||
        formValue['appeldate'] == null ||
        formValue['appeldate'] == ''
      ) {
        this.inValidAppeldate = true;
      } else {
        this.inValidAppeldate = false;
      }
    }
  }

  openConfirmModal() {
    if (this.hpcertificateForm.valid) {
      this.showConfirmModal = true;
    } else {
      this.createHorsParcoursCertificate(); // garde la logique de validation existante
    }
  }

  cancelSubmit() {
    this.showConfirmModal = false;
  }

  confirmSubmit() {
    this.showConfirmModal = false;
    this.createHorsParcoursCertificate();
  }

  resetCreation() {
    this.hpcertificateForm.reset();
    window.scrollTo(0, 0);
  }

  createCohorte(dateAppel: string): string {
    const date = dateAppel.toString().substring(2, 7).replace('-', '');

    const cohorteHorsParcours = 'HSIG' + date + '-FODE';
    return cohorteHorsParcours;
  }

  breadcrumbItems: BreadcrumbItem[] = [
    { label: 'SIGUI' },
    {
      label: 'GESTION DES CERTIFICATS ET WEBINAIRES',
      url: '/dashboard/appels/sigui-certificat',
    },
    {
      label: 'AJOUTER UN NOUVEAU CERTIFICAT HORS PARCOURS',
      url: '/dashboard/appels/hors-sigui-certificate',
    },
  ];
}
